import {ISimplePresentation, ISimplePresentationRunnerController,} from "../SimplePresentationRunner";
import {Game} from "../Game";
import {GameModeNames} from "../server/GameModeNames";
import {gsap} from "gsap";
import { GameMode } from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import { Sound } from "../sound/Sound";

export class FeatureOutroRunner implements ISimplePresentation {

    public shouldRun(): boolean {
        return Game.model.gameData.mode.indexOf(GameMode.FREESPIN) > -1 && Game.model.gameData.nextMode === GameModeNames.NORMAL && !Game.model.gameData.brokeTheBank;
    }

    public start(controller: ISimplePresentationRunnerController): void {
        controller.setSkipCallback();

        let tl: gsap.core.Timeline = gsap.timeline();

        Game.keypadPlugin.setZeroBetSpinCounter(-1);
        Game.model.isMayHemAlreadyTriggered = false;
        Game.soundPlayer.stopSound(Sound.FS_LOOP);
        Game.soundPlayer.stopSound(Sound.MAYHEM_LOOP);
        tl.add(Game.featureOutro.showOutro(() => controller.finish()));
    }
}
